import React from "react";

import { getActiveBrand } from "../../Common/branding/activeBrand";

export function InputBox({
    inputTestID,
    IconComponent,
    placeholder,
    value,
    handleChange = () => {},
    isReadOnly = false,
} = {}) {
    const accentColor =
        getActiveBrand().loginInputAccent || "var(--colorPrimary)";

    return (
        <div
            className="
                d-flex
                rounded
                align-items-center
                pl-1
            "
            style={{ border: `1px solid ${accentColor}` }}
        >
            {IconComponent && (
                <IconComponent
                    aria-hidden="true"
                    style={{
                        width: "2rem",
                        height: "2rem",
                        color: accentColor,
                        flexShrink: 0,
                    }}
                />
            )}
            <input
                data-testid={inputTestID}
                readOnly={isReadOnly}
                name={placeholder}
                placeholder={placeholder}
                type="text"
                className="
                    w-100

                    py-1
                    px-2

                    c-input
                    c-placeholder-light

                    text-light
                    bg-transparent
                    border-0
                "
                value={value}
                onChange={handleChange}
            />
        </div>
    );
}
